import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ChecklistService } from '../checklist.service';
import { OPERATION_OVERLAY_LARGE_CONTENT_DATA } from '@fi-app/utilities/operation-overlay-large/operation-overlay-large-dialog/operation-overlay-large-dialog.component';

@Component({
    selector: 'fi-checklist-checkpoint-view-dialog',
    templateUrl: './checkpoint-view-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checkpoint-view-dialog.component.scss'],
    standalone: false,
})
export class FiChecklistCheckpointViewDialogComponent implements OnInit {
    dialogDataLoaded: boolean = false;
    checklistViewer;

    constructor(
        private checklistService: ChecklistService,
        @Inject(OPERATION_OVERLAY_LARGE_CONTENT_DATA) public data,
    ) {}

    ngOnInit() {
        const checkpointAnswer = this.data.checkpointAnswer;
        this.checklistService
            .getCheckListViewerByAnswerId(checkpointAnswer.CheckListId, checkpointAnswer.Id)
            .then((checklistViewer) => {
                this.checklistViewer = checklistViewer;
                this.dialogDataLoaded = true;
            })
            .catch(() => (this.dialogDataLoaded = true));
    }
}
